module.exports = __webpack_public_path__ + "static/media/organisationDashboard.833aea55.svg";